import { styled, Box, Typography } from '@mui/material';

export const DashboardVariantV2GiverStatusInfoWidgetCardHeaderContainer =
  styled(Box, {
    shouldForwardProp: (prop) => prop !== 'withDivider',
  })<{ withDivider: boolean }>(({ theme, withDivider }) => ({
    paddingBottom: theme.spacing(0.75),
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),

    ...(withDivider && {
      borderBottom: `1px solid ${theme.palette.divider}`,
    }),
  }));

export const DashboardVariantV2GiverStatusInfoWidgetCardHeaderTypographyCurrent =
  styled(Typography)(({ theme }) => ({
    fontSize: theme.typography.pxToRem(60),
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: theme.typography.pxToRem(45),
  }));

export const DashboardVariantV2GiverStatusInfoWidgetCardHeaderTypographyTotal =
  styled(Typography)(({ theme }) => ({
    fontSize: theme.typography.pxToRem(35),
    fontWeight: theme.typography.fontWeightMedium,
    lineHeight: theme.typography.pxToRem(30),
  }));

export const DashboardVariantV2GiverStatusInfoWidgetCardHeaderIconImg = styled(
  'img',
)({
  width: 40,
  height: 40,
});
